import { render, staticRenderFns } from "./t-orm-table-actions.vue?vue&type=template&id=f9903e04&scoped=true&lang=pug"
import script from "./t-orm-table-actions.vue?vue&type=script&lang=js"
export * from "./t-orm-table-actions.vue?vue&type=script&lang=js"
import style0 from "./t-orm-table-actions.vue?vue&type=style&index=0&id=f9903e04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9903e04",
  null
  
)

export default component.exports